import { JsonService }    from '../../app-lite/core/services/json.service';
import { SessionModel }   from '../../app-lite/sessions/models/session';
import { SessionService } from '../../app-lite/sessions/session.service';

export function CoreRun (
  $cookies     : ng.cookies.ICookiesService,
  $window      : ng.IWindowService,
  jsonApi      : JsonService,
  sessionObjAPI: SessionService
) : void {
  const queryParameters = jsonApi.getQueryParameters();

  let session : SessionModel;

  if (queryParameters.puppet || $cookies.get('puppetUser')) {
    sessionObjAPI.validate()
    .then(() => sessionObjAPI.refresh())
    .then(response => {
      session = response;

      if (session.subscription_status === 'canceled' || session.subscription_status === 'trial_ended') {
        $window.location = '/activate.html?puppet=true';
      }

      return sessionObjAPI.getAndSetRights();
    })
    .then(rights => {

      if (session.company_settings.dealer) {
        $window.location = '/dealer.html?puppet=true';
      }
      else if (session.company_settings.first_login) {
        $window.location = '/workshop.html#/company?puppet=true&first_login=true';
      }
      else if (session.super_user) {
        $window.location = '/workshop.html#/admin_dashboard?puppet=true';
      }
      else {
        $window.location = '/workshop.html?puppet=true';
      }

    })
    .catch(err => {
      sessionObjAPI.clear();
    });
  }
  else if (sessionObjAPI.sessionID() && !queryParameters.disconnect) {
    sessionObjAPI.validate()
    .then(() => sessionObjAPI.refresh())
    .then(() => {
      $window.location.assign(
        sessionObjAPI.company().dealer
        ?'/dealer.html#/'
        : '/workshop.html#/'
      );
    });
  }
}